<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle
                :value="isChecked"
                :messages="toggleLabels"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'control-sticky',
    mixins: [baseOption],

    data() {
        return {
            isChecked: false,
            displayName: 'Sticky',
            message: '* makes the element "stick" to the top of the screen, after the user scrolls past it',

            toggleLabels: {
                checked: 'On',
                unchecked: 'Off',
            },

            tailwindDefinitionProp: 'sticky',
        };
    },

    watch: {
        changedOption({ option }) {
            if (option === 'floating-nav') this.onConflict();
        },
    },

    methods: {
        onInput(isChecked) {
            let flexClassNew;

            if (isChecked) {
                flexClassNew = this.addFlexClass({});
            } else {
                this.removeFlexClass('default');
            }

            this.isChecked = isChecked;
            this.onOptionChange(flexClassNew);
        },

        onSelectedElement() {
            this.isChecked = !!this.flexClassGroup[this.screen].default;
        },

        onConflict() {
            this.removeFlexClass('default');
            this.isChecked = false;
        },
    },
};
</script>
